import React, { useState } from 'react';
import {
  Alert,
  Button,
  Progress,
  CircularProgress,
  Spinner,
  Stack,
} from '@/components/ui';
import { useNotificationStore } from '@/stores/notificationStore';
import { CodeBlock } from '../CodeBlock';
import { SectionWrapper } from '../SectionWrapper';

export function FeedbackSection() {
  const [progressValue, setProgressValue] = useState(65);

  return (
    <SectionWrapper title="Feedback Components">
        {/* Alerts */}
        <div>
          <h3 className="text-lg font-semibold mb-4">Alerts</h3>
          <Stack spacing={4}>
            <Alert variant="info" title="Information">
              This is an informational message.
            </Alert>
            <Alert variant="success" title="Success!">
              Your operation completed successfully.
            </Alert>
            <Alert variant="warning" title="Warning">
              Please review this important information.
            </Alert>
            <Alert variant="error" title="Error" onClose={() => {}}>
              Something went wrong. Please try again.
            </Alert>
          </Stack>
          <CodeBlock>
{`<Alert variant="info" title="Information">
  This is an informational message.
</Alert>
<Alert variant="success" title="Success!">
  Your operation completed successfully.
</Alert>
<Alert variant="error" title="Error" onClose={() => {}}>
  Something went wrong. Please try again.
</Alert>`}
          </CodeBlock>
        </div>

        {/* Toast Notifications */}
        <div>
          <h3 className="text-lg font-semibold mb-4">Toast Notifications</h3>
          <div className="flex flex-wrap gap-2">
            <Button
              variant="outline"
              onClick={() => useNotificationStore.getState().success('Operation completed!')}
            >
              Success Toast
            </Button>
            <Button
              variant="outline"
              onClick={() => useNotificationStore.getState().error('Something went wrong!')}
            >
              Error Toast
            </Button>
            <Button
              variant="outline"
              onClick={() => useNotificationStore.getState().info('This is a detailed message')}
            >
              Info Toast
            </Button>
            <Button
              variant="outline"
              onClick={() => {
                useNotificationStore.getState().info('Loading...');
                setTimeout(() => useNotificationStore.getState().success('Loaded successfully!'), 2000);
              }}
            >
              Promise Toast
            </Button>
          </div>
          <CodeBlock>
{`import { showToast } from '@/components/ui';

// Simple toast
showToast.success('Operation completed!');
showToast.error('Something went wrong!');

// Toast with title and description
showToast.info({
  title: 'Info',
  description: 'This is a detailed message'
});

// Promise toast
showToast.promise(fetchData(), {
  loading: 'Loading...',
  success: 'Loaded successfully!',
  error: 'Failed to load',
});`}
          </CodeBlock>
        </div>

        {/* Progress */}
        <div>
          <h3 className="text-lg font-semibold mb-4">Progress Indicators</h3>
          <Stack spacing={6}>
            <div>
              <p className="text-sm text-muted-foreground mb-2">Linear Progress</p>
              <Stack spacing={3}>
                <Progress value={progressValue} max={100} />
                <Progress value={75} max={100} showLabel />
                <div className="flex items-center gap-2">
                  <Button size="sm" onClick={() => setProgressValue(Math.max(0, progressValue - 10))}>
                    -10
                  </Button>
                  <Button size="sm" onClick={() => setProgressValue(Math.min(100, progressValue + 10))}>
                    +10
                  </Button>
                </div>
              </Stack>
            </div>
            <div>
              <p className="text-sm text-muted-foreground mb-2">Circular Progress</p>
              <div className="flex items-center gap-4">
                <CircularProgress value={25} size="sm" />
                <CircularProgress value={50} size="md" />
                <CircularProgress value={75} size="lg" showLabel />
              </div>
            </div>
            <div>
              <p className="text-sm text-muted-foreground mb-2">Loading Spinner</p>
              <div className="flex items-center gap-4">
                <Spinner size="sm" />
                <Spinner size="md" />
                <Spinner size="lg" />
              </div>
            </div>
          </Stack>
          <CodeBlock>
{`<Progress value={75} max={100} />
<Progress value={75} max={100} showLabel />

<CircularProgress value={75} size="lg" showLabel />

<Spinner size="md" />`}
          </CodeBlock>
        </div>
    </SectionWrapper>
  );
}
